import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { acquireAccessToken } from '../../authentication/authConfig';

export const consentApi = createApi({
  reducerPath: 'consentApi',
  baseQuery: fetchBaseQuery({ 
    baseUrl: `${window.config.baseUri}`,
    prepareHeaders: async (headers) => {

      const token = await acquireAccessToken();
        
      // If we have a token set in state, let's assume that we should be passing it.
      if (token) {
        headers.set('authorization', `Bearer ${token}`)
      }
  
      return headers
    },
  }),
  tagTypes: ['Consents'],
  endpoints: (build) => ({
    getTerms: build.query({
      query: (productId) => productId ? `/terms?product=${productId}` : '/terms',
      providesTags: ['Consents'],
    }),
    updateConsent:  build.mutation({
      query: ({ termsId, termsItemId, revision, payload }) => ({
        url: `/terms/${termsId}/${termsItemId}/${revision}/consent`,
        method: 'POST',
        body: payload,
      }),
      transformResponse: (response, meta, arg) => response.data,
      invalidatesTags: ['Consents'],
      async onQueryStarted(
        arg,
        { dispatch, getState, queryFulfilled, requestId, extra, getCacheEntry }
      ) {},
      async onCacheEntryAdded(
        arg,
        { dispatch, getState, extra, requestId, cacheEntryRemoved, cacheDataLoaded, getCacheEntry }
      ) {},
    }),
  }),
});

export const { 
  useGetTermsQuery, 
  useUpdateConsentMutation 
} = consentApi;
